// @ts-nocheck

import { storage } from './';

export const saveUserhasConnected = () => {
  storage.localStorage.save('application:user:has-connected', true);
};

export const getUserhasConnected = () => {
  return !!storage.localStorage.load('application:user:has-connected');
};
